import React from 'react'


export const familyHistoryData: string[] = [
    "Hypertrophic Cardiomyopathy (HCM)",
  "Long QT Syndrome (LQTS)",
  "Brugada Syndrome",
  "Familial Hypercholesterolemia (FH)",
  "Congenital Heart Defects (CHD)",
  "Marfan Syndrome",
  "Ehlers-Danlos Syndrome (EDS)",
  "Alzheimer’s Disease (Early-Onset Familial Type)",
  "Huntington’s Disease",
  "Amyotrophic Lateral Sclerosis (ALS)",
  "Parkinson’s Disease (Genetic Forms)",
  "Epilepsy (Genetic Epileptic Syndromes)",
  "Charcot-Marie-Tooth Disease (CMT)",
  "Spinocerebellar Ataxia (SCA)",
  "Dystonia",
  "Diabetes Mellitus (Type 1 and MODY)",
  "Congenital Hypothyroidism",
  "Multiple Endocrine Neoplasia (MEN Type 1 & 2)",
  "Gaucher Disease",
  "Fabry Disease",
  "Wilson’s Disease",
  "Hemochromatosis",
  "Systemic Lupus Erythematosus (SLE)",
  "Rheumatoid Arthritis (RA)",
  "Ankylosing Spondylitis",
  "Multiple Sclerosis (MS)",
  "Psoriatic Arthritis",
  "Hereditary Breast and Ovarian Cancer Syndrome (HBOC – BRCA1 & BRCA2)",
  "Lynch Syndrome (HNPCC)",
  "Familial Adenomatous Polyposis (FAP)",
  "Li-Fraumeni Syndrome",
  "Retinoblastoma (RB1 mutation)",
  "Von Hippel-Lindau Syndrome",
  "Multiple Endocrine Neoplasia (MEN)",
  "Neurofibromatosis (NF1 and NF2)",
  "Sickle Cell Disease (SCD)",
  "Thalassemia (Alpha and Beta Forms)",
  "Hemophilia (A and B)",
  "Gastric Cancer",
  "Colorectal Cancer",
  "Pancreatic Cancer",
  "Lung Cancer",
  "Prostate Cancer",
  "Leukemia",
  "Lymphoma (Hodgkin’s and Non-Hodgkin’s)",
  "Brain Tumors",
  "Esophageal Cancer",
  "Melanoma",
  "Bladder Cancer",
  "Stomach Ulcers (Peptic Ulcer Disease)",
  "Gastroesophageal Reflux Disease (GERD)",
  "Celiac Disease",
  "Inflammatory Bowel Disease (IBD)",
  "Crohn’s Disease",
  "Ulcerative Colitis",
  "Barrett’s Esophagus",
  "Autoimmune Hepatitis",
  "Alpha-1 Antitrypsin Deficiency",
  "Polycystic Kidney Disease (PKD)",
  "Hereditary Hemorrhagic Telangiectasia (HHT)",
  "Cancer",
  "Other (Please specify)",
];